import React from 'react';
import InteractiveButton from '../../../utils/InteractiveButton';
import { addToCart, getSessionInfo } from '../../../../helpers/craftApi';
export const defaultTranslations = {
    title: 'Add to cart',
};
const defaultIcon = (React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor" },
    React.createElement("path", { d: "M19 5h-14l1.5-2h11zM21.794 5.392l-2.994-3.992c-0.196-0.261-0.494-0.399-0.8-0.4h-12c-0.326 0-0.616 0.156-0.8 0.4l-2.994 3.992c-0.043 0.056-0.081 0.117-0.111 0.182-0.065 0.137-0.096 0.283-0.095 0.426v14c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h14c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-14c0-0.219-0.071-0.422-0.189-0.585-0.004-0.005-0.007-0.010-0.011-0.015zM4 7h16v13c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-14c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707zM15 10c0 0.829-0.335 1.577-0.879 2.121s-1.292 0.879-2.121 0.879-1.577-0.335-2.121-0.879-0.879-1.292-0.879-2.121c0-0.552-0.448-1-1-1s-1 0.448-1 1c0 1.38 0.561 2.632 1.464 3.536s2.156 1.464 3.536 1.464 2.632-0.561 3.536-1.464 1.464-2.156 1.464-3.536c0-0.552-0.448-1-1-1s-1 0.448-1 1z" })));
const defaultSuccessIcon = (React.createElement("svg", { height: "24", width: "24", viewBox: "0 0 448 512" },
    React.createElement("path", { d: "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" })));
export default function AddToCartButton({ purchasableId, className = undefined, icon = defaultIcon, processingIcon = defaultSuccessIcon, successIcon = defaultSuccessIcon, sessionInfoUrl = '/actions/users/session-info', addToCartUrl = '/actions/commerce/cart/update-cart', onSuccess = undefined, onFail = undefined, translations = undefined, }) {
    const t = Object.assign(Object.assign({}, defaultTranslations), translations || {});
    const buttonProps = {
        title: t.title,
        className: `aa-ItemActionButton ${className !== null && className !== void 0 ? className : ''}`,
        children: icon,
    };
    return (React.createElement(InteractiveButton, { defaultStateName: "default", states: {
            default: {
                buttonProps,
            },
            processing: {
                buttonProps: Object.assign(Object.assign({}, buttonProps), { children: processingIcon, disabled: true }),
            },
            success: {
                buttonProps: Object.assign(Object.assign({}, buttonProps), { children: successIcon, disabled: true }),
            },
        }, onClick: ({ setState }) => {
            setState('processing');
            getSessionInfo(sessionInfoUrl)
                .then((session) => addToCart(addToCartUrl, session, purchasableId))
                .then((result) => {
                setState('success');
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(result);
            })
                .catch((error) => {
                setState('default');
                onFail === null || onFail === void 0 ? void 0 : onFail(error);
            });
        } }));
}
